module.exports = __webpack_public_path__ + "aa89b57f33ca28f1fd1986bb806bed4c.svg";